import { Modal, Spacer, isAuthorised } from '@adserve/adserve-react-components';
import React, { useState, useEffect, useContext } from 'react';
import { goalPanelStyle } from '../CampaignBrief/CampaignBriefStyles';
import { pageContainerStyle } from '../CampaignStyles';
import { accountFilter, DefaultInputStatus, goalUIStructure } from '../CampaignBrief/CampaignBriefUtils';
import { DealsLookup } from './CampaignBriefLookupService';
import {
    validateAdvertiser,
    validateAgency,
    validateBudget,
    validateCategory,
    validateDeal,
    validateEndDate,
    validateName,
    validateCampaignGoal,
    validateStartDate
} from '../CampaignBrief/CampaignBriefValidationService';
import {
    GetAllEffectiveVats,
    GetBillingPlanInvoicesByCampaign,
    GetDealsForCampaign,
    GetOffairTypes,
    GetPackages,
    GetVatRates
} from '../../../services/CampaignsDataService';
import RequiredBriefDetails from '../CampaignBrief/RequiredBriefDetails';
import PlanningGoals from './PlanningGoals';
import PackageSelector from './PackageSelector';
import { BusinessTypes, CampaignGoalEnum, DealDiscountPolicy, DealTypes } from '../../../constants/Enums';
import { generateMonthlyPoNumbers } from '../../../services/UtilsService';
import { GetAll } from '../../../services/DataService';
import CampaignDiscounts from './CampaignDiscounts';
import { GetDealDiscounts } from '../../../services/DealService';
import CampaignCommercials from './CampaignCommercials';
import PropertyVariances from './PropertyVariances';
import ValuePot from './ValuePot';
import CampaignContacts from './CampaignContacts';
import CampaignNotes from './CampaignNotes';
import CampaignHistory from './CampaignHistory';
import { getAttachments } from '../../../services/AttachmentService';
import CampaignManagement from './CampaignManagement';
import PropertySelectionDetails from './PropertySelection/PropertySelectionDetails';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';
import moment from 'moment';
import { CancelWorkflowRequest } from '../../../services/WorkflowService';
import CampaignForecasting from './CampaignForecasting';


const dealApiParams = {
    pageNumber: 1,
    pageSize: 100,
    sortField: 'name',
    sortOrder: 'asc'
};
const CampaignBrief = ({
    campaign,
    staticData,
    changeMade,
    readOnly = false,
    bookedReadOnly = false,
    setReadOnly,
    IsValidCampaignName,
    IsValidCampaignGoal,
    IsValidDeal,
    IsValidCategory,
    validJcn,
    setValidJcn,
    validValuePotJcn,
    setValidValuePotJcn,
    ValidationInputCampaignGoal,
    ValidationInputCategory,
    errorValidationCampaignGoal,
    setErrorValidationCampaignGoal,
    errorValidationCategory,
    errorValidationProperty,
    setErrorValidationCategory,
    errorValidationAccount,
    setErrorValidationAccount,
    errorValidationDates,
    setErrorValidationDates,
    validationInput,
    setValidationInput,
    activeRequest = {},
    setActiveRequest,
    activeValuePotRequest = {},
    onDiscountRequestApprovalClick,
    onValuePotRequestApprovalClick,
    discountApprovalWorkflowId,
    valuePotApprovalWorkflowId,
    setBillingAccountId,
    setCampaignStartDate,
    setCampaignEndDate,
    readOnlyProperty,
    setReadOnlyProperty,
    businessType,
    campaignNameStatus,
    setCampaignNameStatus,
    propertySelectionId,
    returnPropsAvailable,
    propertySaved,
    propertyTypes = [],
    passedPropertyId,
    onDelete,
    currentDeal,
    setCurrentDeal,
    selectedGoal,
    setSelectedGoal,
    contactRoles,
    setContactRoles,
    propertyTotals,
    setPropertyTotals,
    recalcTotals,
    revenueTypes = [],
    setRevenueTypes,
    forecastCategories,
    setForecastCategories,
    campaignStages,
    setCampaignStages,
    discountChanged,
    setDiscountChanged,
    discountRequest,
    dealDiscounts,
    setDealDiscounts,
    setDiscountRequest,
    recalculateOffAirs,
    dealStationPrices,
    formatLaydown,
    currentCampaignVersionId,
    campaignVersions,
    isEditClick
}) => {
    const { propertyStats } = useContext(AirtimePlanningContext);
    const [billingTerms, setBillingTerms] = useState([]);
    const [demographics, setDemographics] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [vats, setVats] = useState([]);
    const [deals, setDeals] = useState([]);
    const [packages, setPackages] = useState([]);
    const [minDateActiveProperty, setMinDateActiveProperty] = useState();
    const [maxDateActiveProperty, setMaxDateActiveProperty] = useState();
    const [offairTypes, setOffairTypes] = useState([]);
    const [vatDates, setVatDates] = useState([]);
    const [vatRates, setVatRates] = useState([]);
    const [billingPlanInvoices, setBillingPlanInvoices] = useState([]);
    const lastDayOfCurrentMonth = moment().utc(true).endOf('month').startOf('day');

    const [editingInvoice, setEditingInvoice] = useState({ invoiceDate: lastDayOfCurrentMonth });

    const [nameTracking, setNameTracking] = useState({
        changed: false,
        focused: false
    });

    const [validationResults, setValidationResults] = useState({
        name: DefaultInputStatus(),
        budget: campaign.budget,
        startDate: campaign.startDate,
        endDate: campaign.endDate,
        advertiser: campaign.advertiserAccountId && campaign.advertiserAccountName,
        agency: campaign.agencyAccountId && campaign.agencyAccountId,
        deal: campaign.dealVersionId,
        category: campaign.productCategoryId && campaign.productCategoryName
    });

    const minLengthToStartSearch = 3;
    const [dealManuallySelected, setDealManuallySelected] = useState(false);
    const [showCampaignDiscountPanel, setShowCampaignDiscountPanel] = useState(false);

    const [campaignNotes, setCampaignNotes] = useState();

    const [isBarterCampaign, setIsBarterCampaign] = useState(false);

    const updateCampaign = (key, value, isUserInput = true) => {
        changeMade(key, value, isUserInput);
    };

    function focusName(val) {
        setNameTracking({ ...nameTracking, focused: val });
    }

    function changeName(key, value) {
        setNameTracking({ ...nameTracking, changed: true });
        updateCampaign(key, value);
    }

    useEffect(() => {
        if (!Object.keys(staticData).length) return;

        setRevenueTypes(staticData.revenueTypes);
        setCampaignStages([{ id: -1, name: 'Select...' }, ...staticData.opportunityStages]);
        setForecastCategories([{ id: -1, name: 'Select...' }, ...staticData.forecastCategories]);
        setBillingTerms(
            staticData.billingTerms?.filter(
                (b) => b.name === 'Monthly' || b.name === 'Bespoke' || b.name === 'Do Not Bill'
            )
        );
        setDemographics(staticData.demographics);
        setSurveys(staticData.surveys);
        setVats(staticData.vats);
        if (!campaign.surveyId && typeof campaign !== 'string') {
            campaign.demographicId = staticData.demographics.find((s) => {
                return s.isCosting === 1;
            })?.id;
            campaign.billingTermId = staticData.billingTerms.find((s) => {
                return s.isDefault;
            })?.id;
            campaign.surveyId = staticData.surveys[0].id;
            // campaign.campaignTypeId = staticData.campaignTypes.find((s) => {
            //     return s.isDefault;
            // })?.id;
        }
    }, [staticData, campaign]);

    useEffect(() => {
        if (nameTracking.focused) {
            validateName(campaign.id, campaign.name, minLengthToStartSearch, false).then((results) => {
                setValidationResults({ ...validationResults, name: results });
                IsValidCampaignName(!results?.status?.statusMessage);
            });
        }
    }, [campaign.name]);

    useEffect(() => {
        setSelectedGoal(campaign.campaignGoal?.find((x) => x.selected));
    }, [campaign.campaignGoal]);

    useEffect(() => {
        if (validateDeal(campaign.dealVersionId, true)) {
            IsValidDeal(true);
        } else {
            IsValidDeal(false);
        }
    }, [campaign.dealVersionId]);

    const getInvoices = async () => {
        if (!campaign?.id) {
            return;
        }
        const data = await GetBillingPlanInvoicesByCampaign(campaign?.id);
        setBillingPlanInvoices(data);
        setEditingInvoice({});
    };

    const getOffairTypes = async () => {
        if (!campaign?.id) {
            return;
        }
        const data = await GetOffairTypes();
        setOffairTypes(data);
    };

    const getVatDates = async () => {
        if (!campaign?.id) {
            return;
        }
        const data = await GetAllEffectiveVats();
        setVatDates(data);
    };

    const getVatRates = async () => {
        if (!campaign?.id) {
            return;
        }
        const data = await GetVatRates();
        setVatRates(data);
    };

    useEffect(() => {
        if (
            (campaign.id === window.emptyGuid || campaign.id === undefined) &&
            campaign?.businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()
        ) {
            setReadOnlyProperty(true);
            // onEdit(false);
        } else {
            setReadOnlyProperty(false);
        }
        getInvoices();
        getOffairTypes();
        getVatDates();
        getVatRates();
    }, [campaign.id]);

    useEffect(() => {
        if (validateCampaignGoal(campaign)) {
            IsValidCampaignGoal(true);
        } else {
            IsValidCampaignGoal(false);
        }
    }, [campaign]);

    useEffect(() => {
        if (validateCategory(campaign.productCategoryId, campaign.productCategoryName)) {
            IsValidCategory(true);
        } else {
            IsValidCategory(false);
        }
    }, [campaign.productCategoryName]);

    useEffect(() => {
        if (campaign.budget) {
            setValidationResults({
                ...validationResults,
                budget: validateBudget(campaign.budget, null, campaign.campaignGoal)
            });
        }
    }, [campaign.budget]);

    useEffect(() => {
        setValidationResults({
            ...validationResults,
            startDate: validateStartDate(campaign.startDate, campaign.endDate),
            endDate: validateEndDate(campaign.startDate, campaign.endDate)
        });

        if (campaign.poNumbersJson) {
            campaign.poNumbersJson.multiple = generateMonthlyPoNumbers(
                campaign.startDate,
                campaign.endDate,
                campaign?.poNumbersJson?.multiple
            );
        }
    }, [campaign.startDate]);

    useEffect(() => {
        setValidationResults({
            ...validationResults,
            endDate: validateEndDate(campaign.startDate, campaign.endDate),
            startDate: validateStartDate(campaign.startDate, campaign.endDate)
        });
        if (campaign.poNumbersJson) {
            campaign.poNumbersJson.multiple = generateMonthlyPoNumbers(
                campaign.startDate,
                campaign.endDate,
                campaign?.poNumbersJson?.multiple
            );
        }
    }, [campaign.endDate]);

    useEffect(() => {
        if (dealDiscounts.length > 0) {
            const update = dealDiscounts.map((x) => ({
                ...x,
                campaignPercentageValue: ''
            }));

            if (campaign?.campaignDiscounts?.length) {
                campaign?.campaignDiscounts?.forEach((element) => {
                    const discount = update.find((d) => d.id === element.dealDiscountId);
                    if (discount) {
                        discount.campaignPercentageValue = element.percentageValue;
                    }
                });
            }
            setDealDiscounts(update);
        }
    }, [campaign.campaignDiscounts]);

    useEffect(() => {
        if (!campaign.copyTypes || campaign.copyTypes.length === 0) {
            const standardScript = staticData?.scriptFactors?.find((s) => {
                return s.scriptLength === 30 && !s.scriptLengthFirst && !s.scriptLengthLast;
            });

            const defaultSpotType = staticData?.spotTypes?.find((s) => s.isDefault);

            if (standardScript && defaultSpotType) {
                const newCopyType = {
                    campaignId: campaign.id,
                    spotTypeId: defaultSpotType.id,
                    scriptFactorId: standardScript.id,
                    ratio: 100
                };
                campaign.copyTypes = [newCopyType];
            }
        }

        // ASSP-7750 empty dayparts dropdown caused by applicableDayParts empty array 
        // after campaign is updated - copyTypes above uses the same extended condition - 
        // ditto PlanOptimisationCommand.cs
        if (!campaign.applicableDayParts || campaign.applicableDayParts.length === 0) {
            GetAll('DaypartSet/ApplicableDayPartSet').then((data) => {
                campaign.applicableDayParts = data;
                initialiseDayParts();
            });
        } else {
            initialiseDayParts();
        }

        const unSavedNotes = campaignNotes?.filter((n) => !n.id || n.id === window.emptyGuid);
        if (campaign.id && campaign.id !== window.emptyGuid && unSavedNotes?.length > 0) {
            setCampaignNotes(undefined);
        } else if (campaign.id && campaign.id !== window.emptyGuid && campaignNotes === undefined) {
            handleCampaignNotesChange();
        }
    }, [campaign.id, campaign.applicableDayParts, campaign.copyTypes]);

    useEffect(() => {
        if (campaign.id && campaign.id !== window.emptyGuid && campaign.hasAttachments) {
            handleCampaignNotesChange();
            if (campaign.hasAttachments) changeMade('hasAttachments', false);
        }
    }, [campaign.id, campaign.hasAttachments]);

    useEffect(() => {
        const cNotes = [...(campaign.campaignNotes || []), ...(campaign.campaignAttachments || [])];

        if ((campaign.campaignNotes != null || campaign.campaignAttachments != null) && cNotes !== campaignNotes) {
            setCampaignNotes(cNotes);
        }
    }, [campaign.campaignNotes, campaign.campaignAttachments]);

    useEffect(() => {
        if (
            campaign.dealVersionId !== null &&
            campaign.dealVersionId !== -1 &&
            campaign.dealVersionId !== undefined &&
            campaign.dealVersionId !== window.emptyGuid
        ) {
            GetDealDiscounts(campaign.dealVersionId).then((discounts) => {
                if (campaign?.campaignDiscounts?.length) {
                    campaign?.campaignDiscounts?.forEach((element) => {
                        const discount = discounts.find((d) => d.id === element.dealDiscountId);
                        if (discount) {
                            discount.campaignPercentageValue = element.percentageValue;
                        }
                    });
                }
                setDealDiscounts(discounts);
                setShowCampaignDiscountPanel(discounts.length > 0);
            });
        } else {
            setDealDiscounts([]);
        }
    }, [currentDeal, campaign.dealVersionId]);

    const initialiseDayParts = () => {
        const newDps = [];
        newDps.push({
            id: window.emptyGuid,
            name: window.translate('All Dayparts')
        });
        newDps.push({ id: '', name: '-' });

        for (let i = 0; i < campaign.applicableDayParts.length; i++) {
            const dp = campaign.applicableDayParts[i];
            newDps.push(dp);
            dp.children = [];
            dp.qtrs = [];
            const startHour = dp.fromTime / 3600;
            const endHour = dp.toTime / 3600;
            const startQtr = dp.fromTime / 900;
            const endQtr = dp.toTime / 900;

            for (let j = startQtr; j < endQtr; j++) {
                dp.qtrs.push(j);
            }

            for (let j = startHour; j < endHour; j++) {
                const jpad = j < 10 ? '0' + j : j;
                const j1 = j + 1;
                const jpad1 = j1 < 10 ? '0' + j1 : j1;

                const hour = {
                    id: 'h' + j,
                    name: jpad + ':00-' + jpad1 + ':00',
                    children: [
                        {
                            id: j + ':00',
                            name: jpad + ':00-' + jpad + ':15'
                        },
                        {
                            id: j + ':15',
                            name: jpad + ':15-' + jpad + ':30'
                        },
                        {
                            id: j + ':30',
                            name: jpad + ':30-' + jpad + ':45'
                        },
                        {
                            id: j + ':45',
                            name: jpad + ':45-' + jpad1 + ':00'
                        }
                    ],
                    qtrs: [j * 4 + 0, j * 4 + 1, j * 4 + 2, j * 4 + 3]
                };
                dp.children.push(hour);
            }
        }

        campaign.dayParts = newDps;
    };

    useEffect(() => {
        if (campaign.id !== undefined) {
            const validAdvertiser = validateAdvertiser(campaign.advertiserAccountId, campaign.advertiserAccountName);
            const validAgency = validateAgency(campaign.agencyAccountId, campaign.agencyAccountName);
            setValidationResults({
                ...validationResults,
                advertiser: validAdvertiser || validAgency,
                agency: validAgency || validAdvertiser
            });
        }
    }, [
        campaign.advertiserAccountId,
        campaign.advertiserAccountName,
        campaign.agencyAccountId,
        campaign.agencyAccountName,
        campaign.startDate,
        campaign.endDate
    ]);

    useEffect(() => {
        setValidationResults({
            ...validationResults,
            deal: validateDeal(campaign.dealVersionId)
        });
    }, [campaign.dealVersionId, campaign.dealVersionName]);

    useEffect(() => {
        setValidationResults({
            ...validationResults,
            category: validateCategory(campaign.productCategoryId, campaign.productCategoryName)
        });
    }, [campaign.productCategoryId, campaign.productCategoryName]);

    const updateCampaignGoal = (item) => {
        const copy = [...campaign.campaignGoal];

        const goalToUpdate = copy.find((g) => g.goal === item.goal);
        goalToUpdate.selected = item.selected;
        goalToUpdate.value = item.value;
        goalToUpdate.values = item.values;

        changeMade('campaignGoal', copy);

        // Budget is another prop under the campaign. Update it additionally.
        if (item.goal === CampaignGoalEnum.BUDGET) {
            changeMade('budget', item.value ?? 0);
        }

        if (item.goal === CampaignGoalEnum.WEEKLYBUDGET) {
            // The budget is the total of the weekly split
            const total = item?.values?.reduce((a, b) => {
                return a + parseFloat(b.value);
            }, 0);

            changeMade('budget', total ?? 0);
        }
    };

    const handleCampaignGoalChange = (event) => {
        // ToDo: enhance event handling.
        setErrorValidationCampaignGoal(
            event.target.value.length < 1 || event.target.value === '.' ? 'Campaign goal is required' : ''
        );
    };

    const handleCampaignDiscountChange = (data) => {
        const changes = [...campaign.campaignDiscounts];

        const discount = changes.find((c) => c.dealDiscountId === data.id);

        if (discount) {
            if (data.campaignPercentageValue > 0) {
                discount.percentageValue = data.campaignPercentageValue;
            } else {
                const index = changes.indexOf(discount);
                if (index > -1) {
                    changes.splice(index, 1);
                }
            }
        } else {
            if (data.campaignPercentageValue > 0) {
                changes.push({
                    id: window.newGuid,
                    campaignId: campaign.id,
                    dealDiscountId: data.id,
                    percentageValue: data.campaignPercentageValue
                });
            }
        }

        if (Object.keys(discountRequest)?.length > 0) {
            CancelWorkflowRequest(discountRequest?.id)?.then((res) => {
                setDiscountRequest({});
                setDiscountChanged(true);
            });
        }

        changeMade('campaignDiscounts', changes);
    };

    const handleCampaignContactChange = (data) => {
        changeMade('campaignContacts', data);
    };

    const handleCampaignManagementChange = (key, data) => {
        changeMade('campaignManagement', true);
        if (data !== undefined) updateCampaign(key, data);
    };

    const handleCampaignNotesChange = async () => {
        const params = {
            pageNumber: 1,
            pageSize: 15,
            sortField: 'dateCreated',
            sortOrder: 'asc',
            entityId: campaign.id
        };
        await getAttachments(params, 'campaign').then((data) => {
            setCampaignNotes(data.data.data);
            updateCampaign('campaignNotes', undefined, false);
            updateCampaign('campaignAttachments', undefined, false);
        });
    };

    const checkDeals = async () => {
        const validDeals = await GetDealsForCampaign(accountFilter(campaign));
        setDeals(validDeals);
        if (campaign.dealVersionId === window.emptyGuid || !dealManuallySelected) {
            if (campaign.dealVersionId !== window.emptyGuid) {
                const campaignDeal = validDeals.find((d) => d.id === campaign.dealVersionId);
                if (!campaignDeal) {
                    campaign.dealVersionId = null;
                    updateCampaign('dealVersionId', null);
                    updateCampaign('dealVersionName', null);
                }
            } else {
                if (validDeals.length === 1) {
                    campaign.dealVersionId = validDeals[0].id;
                    updateCampaign('dealVersionId', validDeals[0].id);
                    updateCampaign('dealVersionName', validDeals[0].name);
                } else {
                    campaign.dealVersionId = null;
                    updateCampaign('dealVersionId', null);
                    updateCampaign('dealVersionName', null);
                }
            }
        }
    };

    useEffect(() => {
        if (
            campaign.amending !== undefined &&
            campaign?.campaignStatusName !== 'Qualified Out' &&
            campaign?.campaignStatusName !== 'Cancelled'
        ) {
            setReadOnly(!campaign.amending);
        }
    }, [campaign.amending]);

    useEffect(() => {
        if ('advertiserAccountId' in campaign || 'agencyAccountId' in campaign || 'revenueTypeId' in campaign) {
            checkDeals();
        }
    }, [campaign.advertiserAccountId, campaign.agencyAccountId, campaign.revenueTypeId]);

    useEffect(() => {
        if (!readOnly) campaign.stationsSelected = false;
    }, [readOnly]);

    useEffect(() => {
        setIsBarterCampaign(campaign?.barterAgencyAccountId && campaign?.barterAgencyAccountId !== window.emptyGuid);
    }, [campaign.barterAgencyAccountId]);

    const handleIsBarterCampaign = (value) => {
        setIsBarterCampaign(value);
        if (!value) {
            updateCampaign('barterAgencyAccountId', window.emptyGuid);
            updateCampaign('barterAgencyAccountName', '');
            updateCampaign('barterCommissionRate', '0');
        }
    };

    const isAnyReadOnly = () => {
        let isAnyNotReadonly = bookedReadOnly;
        if (isAnyNotReadonly) isAnyNotReadonly = readOnly;
        return isAnyNotReadonly;
    };

    const isEditable = () => {
        const isAnyNotReadonly = false;
        const isEditableFields =
            campaign?.campaignStatusName === 'Booked' ||
            campaign?.campaignStatusName === 'Running' ||
            campaign?.campaignStatusName === 'Completed' ||
            campaign?.campaignStatusName === 'Draft' ||
            campaign?.campaignStatusName === 'Awaiting Approval';
        if (isEditClick) {
            return !isAuthorised('EDIT_BOOKED_CAM') === false
                ? !isAuthorised('EDIT_BOOKED_CAM') === false && isEditableFields
                : false;
        }
        return isAnyNotReadonly;
    };

    const isNameEditable = () => {
        if (isEditClick) {
            return !isAuthorised('EDIT_BOOKED_CAM') === false
                ? true
                : false;
        }
        return false;
    };

    const enabledEditableForNotesOnly = isEditClick;
    // && (campaign?.campaignStatusName === 'Booked' ||
    //     campaign?.campaignStatusName === 'Running' ||
    //     campaign?.campaignStatusName === 'Completed' ||
    //     campaign?.campaignStatusName === 'Draft' ||
    //     campaign?.campaignStatusName === 'Awaiting Approval');

    return (
        <>
            <div style={pageContainerStyle}>
                <RequiredBriefDetails
                    campaign={campaign}
                    currentSurvey={surveys[0]}
                    nameTracking={nameTracking}
                    updateCampaign={updateCampaign}
                    revenueTypes={revenueTypes?.filter(
                        (r) => r.campaignTypes == null || r.campaignTypes.includes(campaign?.businessType)
                    )}
                    demographics={demographics}
                    billingTerms={billingTerms}
                    validationResults={validationResults}
                    ValidationInputCategory={ValidationInputCategory}
                    errorValidationCategory={errorValidationCategory}
                    setErrorValidationCategory={setErrorValidationCategory}
                    errorValidationAccount={errorValidationAccount}
                    setErrorValidationAccount={setErrorValidationAccount}
                    errorValidationCampaignGoal={errorValidationCampaignGoal}
                    setErrorValidationCampaignGoal={setErrorValidationCampaignGoal}
                    validationInput={validationInput}
                    setValidationInput={setValidationInput}
                    surveys={surveys}
                    focusName={focusName}
                    changeName={changeName}
                    readOnly={readOnly}
                    bookedReadOnly={isAnyReadOnly()}
                    isBarterCampaign={isBarterCampaign}
                    setIsBarterCampaign={handleIsBarterCampaign}
                    setBillingAccountId={setBillingAccountId}
                    setCampaignStartDate={setCampaignStartDate}
                    setCampaignEndDate={setCampaignEndDate}
                    readOnlyProperty={readOnlyProperty}
                    campaignNameStatus={campaignNameStatus}
                    setCampaignNameStatus={setCampaignNameStatus}
                    deals={deals}
                    propertySelectionId={propertySelectionId}
                    returnPropsAvailable={returnPropsAvailable}
                    propertySaved={propertySaved}
                    propertyTypes={propertyTypes}
                    passedPropertyId={passedPropertyId}
                    recalculateOffAirs={recalculateOffAirs}
                    editAuthorisedOnly={isEditable()}
                    canEditName={isNameEditable()}
                />
                <Spacer height={16} width={0} />
                <CampaignForecasting
                    campaignStages={campaignStages}
                    forecastCategories={forecastCategories}
                    campaign={campaign}
                    updateCampaign={updateCampaign}
                    errorValidationDates={errorValidationDates}
                    setErrorValidationDates={setErrorValidationDates}
                    readOnly={readOnly}
                />
                <Spacer height={16} width={0} />
                {businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLocaleLowerCase() ? (
                    <PropertySelectionDetails
                        readOnly={readOnly}
                        bookedReadOnly={isAnyReadOnly()}
                        setReadOnlyProperty={setReadOnlyProperty}
                        updateCampaign={updateCampaign}
                        campaign={campaign}
                        readOnlyProperty={readOnlyProperty}
                        minDateActiveProperty={minDateActiveProperty}
                        setMinDateActiveProperty={setMinDateActiveProperty}
                        maxDateActiveProperty={maxDateActiveProperty}
                        setMaxDateActiveProperty={setMaxDateActiveProperty}
                        propertyTypes={propertyTypes}
                        propertyTotals={propertyTotals}
                        setPropertyTotals={setPropertyTotals}
                        recalcTotals={recalcTotals}
                        onDelete={onDelete}
                        dealStationPrices={dealStationPrices}
                        formatLaydown={formatLaydown}
                        currentCampaignVersionId={currentCampaignVersionId}
                    />
                ) : (
                    <></>
                )}
                <Spacer height={16} width={0} />
                {/* PACKAGE business type is no longer available */}
                
                {businessType?.toLowerCase() === BusinessTypes.AIRTIME.name.toLowerCase() && (
                    <>
                        <PlanningGoals
                            campaign={campaign}
                            budget={campaign?.budget}
                            data={goalUIStructure(campaign?.campaignGoal)}
                            updateCampaignGoal={updateCampaignGoal}
                            onChange={handleCampaignGoalChange}
                            readOnly={readOnly}
                            errorValidationCampaignGoal={errorValidationCampaignGoal}
                            setErrorValidationCampaignGoal={setErrorValidationCampaignGoal}
                            isBurst={false}
                            validationInputCampaignGoal = {ValidationInputCampaignGoal}
                        />

                        <Spacer height={16} width={0} />
                    </>
                )}
                {propertyStats?.some((sp) => sp?.hasVariance === true) && (
                    <PropertyVariances
                        campaign={campaign}
                        updateCampaign={updateCampaign}
                        propertyTypes={propertyTypes}
                    />
                )}
                <Spacer height={16} width={0} />
                {businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLocaleLowerCase() ? (
                    <div style={{ display: 'flex' }}>
                        <CampaignCommercials
                            campaign={campaign}
                            updateCampaign={updateCampaign}
                            billingTerms={billingTerms}
                            vats={vats}
                            deals={deals}
                            validationInput={validationInput}
                            validJcn={validJcn}
                            setValidJcn={setValidJcn}
                            setValidationInput={setValidationInput}
                            setCurrentDeal={setCurrentDeal}
                            setDealManuallySelected={setDealManuallySelected}
                            readOnly={readOnly}
                            setBillingAccountId={setBillingAccountId}
                            readOnlyProperty={readOnlyProperty}
                            bookedReadOnly={isAnyReadOnly()}
                            recalculateOffAirs={recalculateOffAirs}
                            editAuthorisedOnly={isEditable()}
                            campaignVersions={campaignVersions}
                            setReadOnly={setReadOnly}
                        />

                        <Spacer width={16} height={0} />

                        <ValuePot
                            activeRequest={activeValuePotRequest}
                            valuePotApprovalWorkflowId={valuePotApprovalWorkflowId}
                            onValuePotRequestApprovalClick={onValuePotRequestApprovalClick}
                            setValidValuePotJcn={setValidValuePotJcn}
                            validValuePotJcn={validValuePotJcn}
                            campaign={campaign}
                            updateCampaign={updateCampaign}
                            valuePotAvailable={currentDeal?.valuePotAvailable}
                            currentDeal={currentDeal}
                            isSAndP={businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLocaleLowerCase()}
                            selectedGoal={selectedGoal}
                            vatDates={vatDates}
                            readOnly={readOnly}
                        />
                    </div>
                ) : (
                    <CampaignCommercials
                        campaign={campaign}
                        updateCampaign={updateCampaign}
                        billingTerms={billingTerms}
                        vats={vats}
                        deals={deals}
                        validationInput={validationInput}
                        validJcn={validJcn}
                        setValidJcn={setValidJcn}
                        setValidationInput={setValidationInput}
                        setCurrentDeal={setCurrentDeal}
                        setDealManuallySelected={setDealManuallySelected}
                        readOnly={readOnly}
                        setBillingAccountId={setBillingAccountId}
                        readOnlyProperty={readOnlyProperty}
                        recalculateOffAirs={recalculateOffAirs}
                        editAuthorisedOnly={isEditable()}
                        campaignVersions={campaignVersions}
                        setReadOnly={setReadOnly}
                    />
                )}
                {/* ToDo: Include a value pot check when available */}
                {currentDeal?.type === DealTypes.AGENCY &&
                    !!currentDeal?.maxValuePot &&
                    businessType?.toLowerCase() !== BusinessTypes.SANDP.name.toLocaleLowerCase() && (
                        <>
                            <Spacer height={16} width={0} />
                            <ValuePot
                                activeRequest={activeValuePotRequest}
                                valuePotApprovalWorkflowId={valuePotApprovalWorkflowId}
                                onValuePotRequestApprovalClick={onValuePotRequestApprovalClick}
                                setValidValuePotJcn={setValidValuePotJcn}
                                validValuePotJcn={validValuePotJcn}
                                campaign={campaign}
                                updateCampaign={updateCampaign}
                                valuePotAvailable={currentDeal?.valuePotAvailable}
                                currentDeal={currentDeal}
                                isSAndP={businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLocaleLowerCase()}
                                selectedGoal={selectedGoal}
                                vatDates={vatDates}
                                readOnly={readOnly}
                            />
                        </>
                    )}
                {
                    /*
                TODO: this needs fixing so that the readonly flag is also based on whether the campaign has billed. Otherwise we get into a buggers muddle
                when we have billed stuff at 10% discount then try to up it to 20% when the campaign has nearly completed
                */
                    showCampaignDiscountPanel && (
                        <>
                            <Spacer height={16} width={0} />
                            <CampaignDiscounts
                                campaign={campaign}
                                discountData={dealDiscounts}
                                onChange={handleCampaignDiscountChange}
                                activeRequest={activeRequest}
                                onRequestApprovalClick={onDiscountRequestApprovalClick}
                                discountApprovalWorkflowId={discountApprovalWorkflowId}
                                selectedDealDiscountPolicy={currentDeal?.discountPolicy ?? DealDiscountPolicy.ADD.id}
                                readOnly={readOnly}
                                discountChanged={discountChanged}
                                discountRequest={discountRequest}
                            />
                        </>
                    )
                }
                <Spacer height={16} />
                <CampaignManagement
                    campaign={campaign}
                    onCampaignManagementChange={handleCampaignManagementChange}
                    readOnly={isAnyReadOnly() || readOnlyProperty}
                    editAuthorisedOnly={isEditable()}
                />
                <Spacer height={16} />
                <CampaignContacts
                    campaign={campaign}
                    contactRoles={contactRoles}
                    setContactRoles={setContactRoles}
                    onChange={handleCampaignContactChange}
                    readOnly={isAnyReadOnly() || readOnlyProperty}
                />
                <Spacer height={16} />
                <CampaignNotes
                    campaign={campaign}
                    data={campaignNotes}
                    changeMade={changeMade}
                    onChange={handleCampaignNotesChange}
                    readOnly={!enabledEditableForNotesOnly}
                />
                <Spacer height={16} />
                <CampaignHistory campaign={campaign} />
            </div>
        </>
    );
};

export default CampaignBrief;
